<template>
  <div>
    <v-container fluid class="mx-12 my-6">
      <div class="d-flex flex-row mb-4">
        <div class="card-label d-flex flex-row mb-4">
          <v-icon>mdi-cash-multiple</v-icon>
          <p class="mb-0 ml-4 subtitle-1 font-weight-bold">Preview PDCs</p>
        </div>
        <div class="flex-grow-1"></div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              depressed
              rounded
              color="primary"
              class="mr-2 font-weight-bold"
              @click="openImportFile"
              v-on="on"
            >
              <v-icon class="pr-1">mdi-file-upload</v-icon>Import New File
            </v-btn>
          </template>
          <p style="color: white">
            Create and import PDCs by uploading a CSV File
          </p>
        </v-tooltip>
      </div>
      <v-card elevation="0" class="card-container px-8 py-4">
        <v-data-table
          fixed-header
          :items="entries"
          :headers="headers"
          height="450"
          disable-pagination
          disable-filtering
          disable-sort
          hide-default-footer
          dense
        >
          <template v-slot:item="{ item, index }">
            <tr v-if="item">
              <td>
                <p class="caption">{{ index + 1 }}</p>
              </td>
              <td>
                <v-checkbox
                  v-model="item.selected"
                  hide-details
                  dense
                  class="mt-0"
                  @change="checkSelected"
                ></v-checkbox>
              </td>
              <td>
                <p class="caption">{{ item.bedId }}</p>
              </td>
              <td>
                <p class="caption">{{ item.routingNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.accountNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.checkNo }}</p>
              </td>
              <td>
                <p class="caption">{{ item.startDate }}</p>
              </td>
              <td>
                <p class="caption">{{ item.endDate }}</p>
              </td>
              <td>
                <p class="caption">{{ item.checkDate }}</p>
              </td>
              <td>
                <p class="caption">{{ item.category }}</p>
              </td>
              <td>
                <p class="caption">{{ item.bank }}</p>
              </td>
              <td>
                <p class="caption">{{ item.description }}</p>
              </td>
              <td>
                <p class="caption">{{ formatCurrency(item.amount) }}</p>
              </td>
            </tr>
            <tr v-else>
              <td>
                <p class="caption">{{ index + 1 }}</p>
              </td>
              <td colspan="12">
                <div class="d-flex justify-center">
                  <p class="grey--text">Invalid Entry</p>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-bold"
            color="primary darken-1"
            text
            :disabled="!isValid"
            @click="finish"
            >Begin import</v-btn
          >
          <v-btn
            class="font-weight-bold"
            color="grey darken-1"
            text
            @click="cancel"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-container>
    <ImportPDCFileUpload
      ref="importPDCFileUpload"
      :reload-data="reloadData"
    ></ImportPDCFileUpload>
  </div>
</template>

<script>
import ImportPDCFileUpload from '../components/pdc/ImportPDCFileUpload.vue'
export default {
  components: {
    ImportPDCFileUpload
  },
  data() {
    return {
      entries: [],
      headers: [
        { value: 'index', text: 'Entry' },
        { value: 'select', text: 'Select' },
        { value: 'bedId', text: 'Unit ID' },
        { value: 'routingNo', text: 'Routing No.' },
        { value: 'accountNo', text: 'Account No.' },
        { value: 'checkNo', text: 'Check No.' },
        { value: 'startDate', text: 'Start Date' },
        { value: 'endDate', text: 'End Date' },
        { value: 'checkDate', text: 'Check Date' },
        { value: 'category', text: 'Category' },
        { value: 'bank', text: 'Bank' },
        { value: 'description', text: 'Description' },
        { value: 'amount', text: 'Amount' }
      ],
      isValid: false
    }
  },
  methods: {
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    checkSelected() {
      this.isValid = this.entries.filter((p) => p && p.selected).length
    },
    openImportFile() {
      this.$refs.importPDCFileUpload.open()
    },
    async finish() {
      if (
        await this.$root.$confirm({
          message: `Are you sure you want to import the pdcs?`,
          confirmText: 'Yes',
          options: {
            width: 400
          }
        })
      ) {
        this.$root.$setLoading(true)
        try {
          const result = await this.$store.dispatch(
            'pdcs/submitBatchImportEntries',
            {
              entries: this.entries
            }
          )
          if (result) {
            this.$root.$setLoading(false)
            this.$root
              .$confirm({
                title: 'Import PDCs',
                message: `Successfully created PDCs`,
                reconfirmOnly: true,
                confirmText: 'OK',
                options: {
                  color: 'primary'
                }
              })
              .then(() => {
                this.$router.replace('/units')
              })
          } else {
            this.showErrorDialog(
              'No PDCs were imported. Please check your file again'
            )
          }
        } catch (err) {
          this.showErrorDialog()
        }
      }
    },
    cancel() {
      this.$router.replace('/property')
    },
    reloadData() {
      this.entries = this.$store.getters['pdcs/getBatchImportPreview']
      this.entries = this.entries.length
        ? this.entries.map((entry) => {
            if (entry) {
              entry.selected = true
            }
            return entry
          })
        : []

      this.checkSelected()
    },
    showErrorDialog(msg) {
      const defaultMessage = `There was an error importing PDCs`
      this.$root.$setLoading(false)
      this.$root.$confirm({
        title: 'Import PDCs',
        message: msg || defaultMessage,
        reconfirmOnly: true,
        confirmText: 'OK',
        options: {
          color: 'error'
        }
      })
    }
  }
}
</script>
